module.exports = __webpack_public_path__ + "img/husky.2365b517.jpg";